// extracted by mini-css-extract-plugin
module.exports = {"headingStyle":"QuickTour_headingStyle__2NDKu","FooterQ":"QuickTour_FooterQ__26WiU"};